import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import DocsHelper from "util/DocsHelper";
import usePermissions from "hooks/usePermissions";
import { DocumentTitle, PageHeader, Icon } from "components/common";
import { Row, Col, Button } from "components/bootstrap";
import { useModalContext } from "common/contexts";
import ProceduresList from "./EventProcedureList";
import StepsList from "./EventProcedureStepList";
function SecurityUI({ viewType }) {
  const { t } = useTranslation("enterprise_security_events");
  const DESCRIPTION = /* @__PURE__ */ React.createElement("span", null, t("security_ui.description"));
  const { setModal } = useModalContext();
  const openEventProcedureModal = () => {
    setModal("CREATE-EVENT-PROCEDURE");
  };
  const openEventProcedureStepModal = () => {
    setModal("CREATE-EVENT-PROCEDURE-STEP");
  };
  const { isPermitted } = usePermissions();
  const canCreateEventProcedures = useMemo(() => isPermitted("event_procedures:create"), [isPermitted]);
  const canCreateEventProcedureSteps = useMemo(() => isPermitted("event_procedure_steps:create"), [isPermitted]);
  return /* @__PURE__ */ React.createElement(
    DocumentTitle,
    {
      title: viewType === "procedures" ? t("security_ui.event_procedures") : t("security_ui.event_procedure_steps")
    },
    viewType === "procedures" ? /* @__PURE__ */ React.createElement(
      PageHeader,
      {
        title: t("security_ui.event_procedures"),
        documentationLink: {
          title: t("security_ui.documentation_link"),
          path: DocsHelper.PAGES.EVENT_PROCEDURES
        },
        actions: canCreateEventProcedures && /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => openEventProcedureModal() }, /* @__PURE__ */ React.createElement(Icon, { name: "add", size: "xs" }), t("security_ui.create_event_procedure"))
      },
      /* @__PURE__ */ React.createElement("span", null, DESCRIPTION)
    ) : /* @__PURE__ */ React.createElement(
      PageHeader,
      {
        title: t("security_ui.event_procedure_steps"),
        documentationLink: {
          title: t("security_ui.documentation_link"),
          path: DocsHelper.PAGES.EVENT_PROCEDURES
        },
        actions: canCreateEventProcedureSteps && /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => openEventProcedureStepModal() }, /* @__PURE__ */ React.createElement(Icon, { name: "add", size: "xs" }), t("security_ui.create_event_procedure_step"))
      },
      /* @__PURE__ */ React.createElement("span", null, DESCRIPTION)
    ),
    /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, viewType === "procedures" ? /* @__PURE__ */ React.createElement(ProceduresList, null) : /* @__PURE__ */ React.createElement(StepsList, null)))
  );
}
export default SecurityUI;
